export * from './ColorSpecs/const';
export const colorAction = 'colorify';
export var Colors;
(function (Colors) {
    Colors["Gray"] = "gray";
    Colors["Yellow"] = "yellow";
    Colors["Orange"] = "orange";
    Colors["Red"] = "red";
    Colors["Green"] = "green";
    Colors["Blue"] = "blue";
    Colors["Violet"] = "violet";
})(Colors || (Colors = {}));
